/** @jsxImportSource @emotion/react */
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import UDText from 'ud-ui/components/text';
import { Day as IDay } from 'modules/schedule/domain/interfaces/day';
import { setSelectedDate } from 'modules/schedule/store';
import { MainBlock } from './styles';

interface IProps extends IDay {}

function Day(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { date, status, isSelected } = props;

  const onClick = useCallback(() => {
    if (!date) return;
    dispatch(setSelectedDate(date));
  }, [date, dispatch]);

  return (
    <MainBlock onClick={onClick} className={classNames(isSelected ? 'active' : status)}>
      <UDText style={{ color: 'inherit', lineHeight: 'inherit' }} type={'footnote'}>
        {date ? new Date(date).getDate() : undefined}
      </UDText>
    </MainBlock>
  );
}

export default Day;
